//
//
//
//
//
//
//
//
//

export default {
  name:"AppleWatchIcon",
  props:{
    size: {
      type: String,
      default: 'inherit'
    },
    rotate: {
      type: String,
      default: '0'
    },
    fill: {
      type: String,
      default: 'none'
    }
  }
};
